// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__33gCW","unreadBadge":"styles_unreadBadge__1b8iG","modalContent":"styles_modalContent__1I1Zk","modal":"styles_modal__12N6s"};